import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOCALES, LOCALE_LABELS, Locale, LANGUAGE_STORAGE_KEY, useI18n } from '../i18n';

const LanguageSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { locale, switchTo } = useI18n();

  const switchLocale = (next: Locale) => {
    const target = switchTo(next);
    if (!target) return;
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, next);
    } catch {
      // ignore storage failures
    }
    navigate(`${target.pathname}${target.search}${target.hash}`);
  };

  return (
    <div className={`inline-flex items-center rounded-full border border-slate-200 bg-white px-2 py-1 text-sm shadow-sm ${className}`}>
      {LOCALES.map((l, index) => (
        <React.Fragment key={l}>
          {index > 0 && <span aria-hidden="true" className="mx-1 text-slate-300">|</span>}
          <button
            type="button"
            onClick={() => switchLocale(l)}
            aria-current={l === locale ? 'true' : undefined}
            className={`rounded-full px-2 py-0.5 transition-colors duration-200 ${
              l === locale ? 'font-bold text-primary' : 'text-gray-500 hover:text-primary'
            }`}
          >
            {LOCALE_LABELS[l]}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
